import {
  AppBar,
  Box,
  CardMedia,
  Container,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  Button,
  Stack,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogProps,
  Divider,
  InputAdornment,
  Menu,
  MenuItem,
  Select,
  FormControl,
  Grid,
  SelectProps,
  SelectChangeEvent,
  Tooltip,
  ListItem,
  Collapse,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { Link as RouterLink } from 'react-router-dom';
import {
  ApplicationsIcon,
  FundsSetup,
  RiskProfile,
  AMCAdmins,
  Reports,
  DashboardIcon,
} from './customSVGs';
import { useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux-store/actions/auth';
import MenuIcon from '@mui/icons-material/Menu';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CancelIcon from '@mui/icons-material/Cancel';
import { RootStateType } from '../redux-store/reducers';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {
  APPLICANT_CVL_FORM_SIGNING_STATUS,
  APPLICATION_TYPE,
  CVL_MODIFICATION_STATUS,
  ENABLE_Email_Consent,
  ENABLE_USER_EXPORT,
  USER_ROLES,
} from '../utils/constant';
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import { Formik, useField, useFormikContext } from 'formik';
import { getCountryCodes } from '../utils/utilityFunctions';
import { Applicant } from '../redux-store/types/api-types';
import { Gridstyles, Item, ItemDetails } from './ApplicationDetails';
import { SubHeading } from './investors/components';
import { KeyValue } from './ApplicationDetails/contributor';
import { JsxAttributeLike } from 'typescript';
import * as yup from 'yup';
import { MFTextField } from '../lib/formik';
import MFCheckbox from '../lib/formik/Checkbox';
import { useHistory } from 'react-router';
import { getParams } from '../redux-store/actions/application';
import { initialState } from '../redux-store/reducers/queryParams';
import { renderFilteredOptions, SearchFieldWrapper } from '../lib/formik/searchSelectField';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import CloseIcon from '@mui/icons-material/Close';
import { InvestorConsentDetailsProps, checkKycUpdateCheck } from './dashboard/applicationslist';
import { LoadingButton } from '@mui/lab';
import { exportUsersData } from '../redux-store/actions/userManagement';
import { reportDownload } from './Reports/report-utils';
import { AccessibleDialog } from '../lib/AccessibleDialog';
import { color } from 'chart.js/helpers';

export function OtpTimer({ onResend }: { onResend: () => void }): JSX.Element {
  const [counter, setCounter] = useState(60);

  // Third Attempts
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* Visually hidden live region for screen readers only */}
      <Typography
        role="status"
        aria-live="polite"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: '0',
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          border: '0',
        }}>
        {counter === 0 ? 'OTP has expired. You can now resend.' : ''}
      </Typography>

      <Button
        sx={{
          mt: 2,
          fontSize: 16,
          fontWeight: 500,
          color: ' #BD1A1A',
          p: 0,
          ':hover': { background: 'none' },
        }}
        disabled={counter > 0}
        onClick={() => {
          onResend();
          setCounter(60);
        }}>
        Resend OTP
      </Button>

      <Typography component="p" sx={{ mt: 1, fontSize: 14 }}>
        {counter > 0 && `in ${counter} seconds`}
      </Typography>
    </Box>
  );
}

// Footer
export const Footer = (): JSX.Element => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 1.2,
        minHeight: 'fit-content',
      }}>
      <Typography
        component="span"
        sx={{
          color: 'common.white',
          lineHeight: 1.5,
          letterSpacing: '0.12em',
          wordSpacing: '0.16em',
          mr: 1,
        }}>
        Powered By
      </Typography>
      <CardMedia
        component="img"
        src="/images/kfin-new-logo.png"
        alt="kFintech Logo"
        sx={{
          width: 'auto',
          height: '1.5rem',
        }}
      />
    </Box>
  );
};
// Footer End

// Login Layout
export const LoginLayout = ({
  LoginText,
  children,
}: {
  LoginText: string;
  children: JSX.Element;
}): JSX.Element => {
  return (
    <Stack
      sx={{
        minHeight: '100vh',
        background: '#f2f6f8 url("/images/login-bg.svg")',
        backgroundSize: 'cover',
      }}>
      <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
        <Box>
          <CardMedia
            component="img"
            src="/images/kfin-logo.svg"
            alt="kFintech Logo"
            sx={{ width: 'unset', m: 3 }}
          />
        </Box>
      </AppBar>
      <Box
        component="main"
        sx={{
          // height: 'calc(100vh - 43px)',
          flex: 1,
          display: 'grid',
          placeItems: 'center',
          // mt: '-88px',
        }}>
        <Box
          sx={{
            bgcolor: 'grey.50',
            height: { xs: 'unset', sm: 'unset' },
            minHeight: { xs: 'unset', sm: '470px' },
            width: 'clamp(300px, 70%, 500px)',
            px: { xs: '25px', sm: '80px' },
            py: '50px',
            mb: 2,
            borderRadius: '10px',
            boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
          }}>
          <Typography
            component="h2"
            variant="h5"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 28,
              fontWeight: 600,
              color: 'primary.main',
              mb: '50px',
              textAlign: 'center',
            }}>
            {LoginText}
          </Typography>
          {children}
        </Box>
      </Box>
      {/* <Footer /> */}
    </Stack>
  );
};
// Login Layout End

// Header & Sidenav
const drawerWidth = '169px';

interface MenuButtonProps {
  to?: string | null;
  text: string;
  children: JSX.Element;
  downArrow?: boolean;
  onClick?: () => void;
  // Paths that should highlight this (parent) button when it has no `to` of its own.
  activeMatchPaths?: string[];
  // This allows aria-expanded, aria-controls, and id to pass down flawlessly
  [key: string]: any;
}

const APPLICATIONS_ACTIVE_PATHS = [
  '/onboarding',
  '/applications',
  '/application',
  '/application-details/:id',
  '/non-individual-application-details/:id',
  '/non-individual-application',
  '/application-preview/:id',
  '/non-individual-application-preview/:id',
  '/view-consent-email-list',
  '/view-photo-capture-list',
];

const MenuButton = ({
  to = null,
  text,
  children,
  downArrow,
  onClick,
  activeMatchPaths,
  ...props // Captures accessibility and system attributes cleanly
}: MenuButtonProps) => {
  const { path } = useRouteMatch();

  const match = to
    ? path.includes(to)
    : (activeMatchPaths || APPLICATIONS_ACTIVE_PATHS).includes(path);

  const disabled = to === null;

  return (
    <ListItemButton
      onClick={onClick}
      // FIXED: Forces 'button' element behavior if it doesn't route to an explicit link destination
      component={disabled ? 'button' : RouterLink}
      aria-current={disabled ? undefined : 'page'}
      to={disabled ? undefined : to || ''}
      {...props} // FIXED: Spreads aria-expanded, aria-controls, and element IDs onto the button DOM element
      sx={{
        p: { xs: '10px 20px', md: 3 },
        border: 'none', // Prevents default browser button borders
        width: '100%',
        background: match
          ? 'linear-gradient(88.93deg, rgba(51, 127, 201, 0.10) 24.43%, rgba(51, 127, 201, 0) 93.37%)'
          : 'transparent',

        color: match ? '#0A2A5C' : '#293139',
        stroke: match ? '#0A2A5C' : '#293139',
        strokeWidth: 0,

        '.MuiSvgIcon-root': {
          opacity: '1 !important',
          color: match ? '#0A2A5C !important' : '#293139 !important',
        },

        ':hover': {
          cursor: 'pointer',
          background: match
            ? 'linear-gradient(88.93deg, rgba(51, 127, 201, 0.10) 24.43%, rgba(51, 127, 201, 0) 93.37%)'
            : 'transparent',
          '.MuiSvgIcon-root': {
            color: match ? '#0A2A5C !important' : '#131836 !important',
          },
        },
        textAlign: 'center',
        '&.Mui-focusVisible': {
          outline: '2px solid #0A2A5C',
          outlineOffset: '-2px',
        },
      }}>
      {children}
      <ListItemText primary={text} secondary={downArrow && <ExpandMoreIcon />} />
    </ListItemButton>
  );
};

const KfinDrawer = ({ onToggleClick }: { onToggleClick: () => void }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  const { role = '', adminSupport } = useSelector((store: RootStateType) => store.auth);

  return (
    <Box>
      <List
        component="ul"
        aria-label="Main Sidebar Navigation"
        sx={{
          pt: { xs: 2, md: 1 },
          '& .MuiListItemButton-root': {
            mb: 1,
            flexDirection: { xs: 'row', md: 'column' },
            '& .MuiListItemText-root': { mx: { xs: 1, md: 0 } },
            '& .MuiListItemText-root span': {
              fontFamily: 'Poppins, sans-serif',
              fontSize: 16,
              fontWeight: 500,
            },
          },
        }}>
        {/* Mobile Close Button Row */}
        <ListItem
          component="li"
          sx={{ p: 0, display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
          <IconButton onClick={onToggleClick} aria-label="close drawer" sx={{ color: '#00D9DA' }}>
            <CancelIcon />
          </IconButton>
        </ListItem>

        {/* Dashboard Link Option */}
        <ListItem component="li" sx={{ p: 0 }}>
          <MenuButton to="/dashboard" text="Dashboard">
            <DashboardIcon />
          </MenuButton>
        </ListItem>

        {/* Parent Category List Container Element */}
        <ListItem component="li" sx={{ p: 0, display: 'block' }}>
          <MenuButton
            text="Applications"
            downArrow={!open}
            onClick={() => setOpen(!open)}
            // FIXED: Passed directly to the button element to correctly announce state changes
            aria-expanded={open}>
            <ApplicationsIcon />
          </MenuButton>

          {/* Clean accessible collapse framework container block */}
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List
              component="ul"
              aria-label="Applications Submenu"
              sx={{
                p: 0,
                textAlign: 'center',
                '.MuiTypography-root': {
                  my: 1,
                  py: 1,
                  fontWeight: 500,
                  fontSize: 14,
                  display: 'block',
                  textDecoration: 'none',
                  color: 'text.primary',
                  background:
                    'linear-gradient(90deg, rgba(15, 212, 216, 0.072) 0%, rgba(97, 209, 214, 0) 100%)',
                },
              }}>
              <Typography
                component={RouterLink}
                to="/onboarding"
                onClick={() => {
                  dispatch(getParams(initialState));
                }}>
                Add New
              </Typography>
              <Typography
                component={RouterLink}
                to="/applications"
                onClick={() => {
                  dispatch(getParams(initialState));
                }}>
                View Existing
              </Typography>
              {ENABLE_Email_Consent && (
                <Typography component={RouterLink} to="/view-consent-email-list">
                  View Email Consent
                </Typography>
              )}
            </List>
          </Collapse>
        </ListItem>

        {USER_ROLES.AMC_ADMIN === role && (
          <>
            {/* User Management Parent Row Block */}
            <ListItem component="li" sx={{ p: 0, display: 'block' }}>
              <MenuButton
                text="User Management"
                downArrow={!openUser}
                onClick={() => setOpenUser(!openUser)}
                activeMatchPaths={['/user-management']}
                // FIXED: Passed directly to the button element to correctly announce state changes
                aria-expanded={openUser}>
                <PersonOutlineOutlinedIcon />
              </MenuButton>

              <Collapse in={openUser} timeout="auto" unmountOnExit>
                <List
                  component="ul"
                  aria-label="User Management Submenu"
                  sx={{
                    p: 0,
                    textAlign: 'center',
                    '.MuiTypography-root': {
                      my: 1,
                      py: 1,
                      fontWeight: 500,
                      fontSize: 14,
                      display: 'block',
                      textDecoration: 'none',
                      color: 'text.primary',
                      background:
                        'linear-gradient(90deg, rgba(15, 212, 216, 0.072) 0%, rgba(97, 209, 214, 0) 100%)',
                    },
                  }}>
                  <Typography component={RouterLink} to="/user-management">
                    Users
                  </Typography>
                  <Typography component={RouterLink} to="/create-bulk-user">
                    Create Bulk Users
                  </Typography>
                </List>
              </Collapse>
            </ListItem>

            {/* Standard Single Node Sidebar Links */}
            <ListItem component="li" sx={{ p: 0 }}>
              <MenuButton text="Strategy Setup" to="/strategy-setup">
                <FundsSetup />
              </MenuButton>
            </ListItem>

            <ListItem component="li" sx={{ p: 0 }}>
              <MenuButton text="Reports" to="/reports">
                <Reports />
              </MenuButton>
            </ListItem>

            <ListItem component="li" sx={{ p: 0 }}>
              <MenuButton text="MITC" to="/mitc">
                <TextSnippetOutlinedIcon />
              </MenuButton>
            </ListItem>

            {adminSupport && (
              <ListItem component="li" sx={{ p: 0 }}>
                <MenuButton text="Admin Support" to="/admin-support">
                  <RiskProfile />
                </MenuButton>
              </ListItem>
            )}
          </>
        )}

        {USER_ROLES.SUPER_ADMIN === role && (
          <ListItem component="li" sx={{ p: 0 }}>
            <MenuButton text="AMC Admins" to="/amc-admins">
              <AMCAdmins />
            </MenuButton>
          </ListItem>
        )}
      </List>
    </Box>
  );
};

export const HeaderSidenav = (): JSX.Element => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: 'white',
          boxShadow: 'none',
        }}>
        <Toolbar sx={{ px: { xs: 2, lg: 6 } }}>
          <Box sx={{ mr: 'auto' }}>
            <CardMedia
              component="img"
              src="/images/kfin-logo.svg"
              alt="kFintech Logo"
              sx={{ width: 'unset' }}
            />
          </Box>
          {/* <Box sx={{ display: 'flex' }}>
            <IconButton onClick={() => history.push('/profile')}>
              <AccountCircleIcon fontSize="large" sx={{ color: 'primary.main' }} />
            </IconButton>
          </Box> */}
          <Box sx={{ display: 'flex' }}>
            <IconButton aria-label="Logout" onClick={() => dispatch(logout())}>
              <PowerSettingsNewIcon fontSize="large" sx={{ color: 'primary.main' }} />
            </IconButton>
          </Box>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' }, color: 'secondary.main' }}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        aria-label="side nav">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="right"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}>
          <KfinDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              mt: '100px',
              border: 0,
              maxHeight: 'calc(100vh - 100px)',
              overflow: 'scroll',
              // pb: 'calc(65px + 10%)',
              // justifyContent: 'center',
            },
          }}
          open>
          <KfinDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
      </Box>
    </>
  );
};
// Header & Sidenav END

export const CommonLayout = ({ children }: { children: JSX.Element }): JSX.Element => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          // minHeight: 'calc(100vh - 43px)',
          // overflow: 'auto',
          flexDirection: 'column',
        }}>
        <HeaderSidenav />
        <Box
          component="main"
          sx={{
            mt: '65px',
            ml: { xs: 0, md: drawerWidth },
            p: { xs: 2, md: '50px' },
            pt: { md: '20px' },
            borderRadius: '50px 0 0 0',
            bgcolor: { xs: '', md: 'rgba(238, 244, 251, 0.5)' },
            minHeight: 'calc(100vh - 108px)',
            //overflow: 'auto',
          }}>
          <Container maxWidth="lg" disableGutters={true}>
            {children}
          </Container>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};

export const UserManagementCommonLayout = ({
  children,
  showButton,
}: {
  children: JSX.Element;
  showButton: boolean;
}): JSX.Element => {
  const dispatch = useDispatch();
  const [isSendLoading, setIsSendLoading] = useState(false);

  const downloadUsersData = async () => {
    try {
      setIsSendLoading(true);
      const res = await dispatch(exportUsersData());
      reportDownload(res as unknown as Blob, 'pms-onboarding-users.xlsx');
    } catch (e) {
      setIsSendLoading(false);
      console.error((e as Error).message);
    } finally {
      setIsSendLoading(false);
    }
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          // minHeight: 'calc(100vh - 43px)',
          // overflow: 'auto',
          flexDirection: 'column',
        }}>
        <HeaderSidenav />
        <Box
          component="main"
          sx={{
            mt: '65px',
            ml: { xs: 0, md: drawerWidth },
            p: { xs: 0, md: '50px' },
            pt: { md: '20px' },
            borderRadius: { xs: '', sm: '50px 0 0 0' },
            bgcolor: 'rgba(238, 244, 251, 0.5)',
            minHeight: 'calc(100vh - 108px)',
            //overflow: 'auto',
          }}>
          <Container maxWidth="lg" disableGutters={true}>
            {showButton && ENABLE_USER_EXPORT && (
              <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
                <Tooltip title="Click here to download users data">
                  <LoadingButton
                    loadingPosition="start"
                    aria-label="Download Users Data"
                    type="submit"
                    loading={isSendLoading}
                    variant="contained"
                    sx={{
                      fontSize: 12,
                      minWidth: isSendLoading ? 220 : '',
                      letterSpacing: 1,
                      fontWeight: 400,
                      px: isSendLoading ? 0 : 2,
                      py: 1,
                      mt: 1,
                    }}
                    onClick={downloadUsersData}>
                    Download Users Data
                  </LoadingButton>
                </Tooltip>
              </Box>
            )}
            {children}
          </Container>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};
export const ConfirmationDialog = ({
  open,
  setOpen,
  message = 'Are you sure you want to delete?',
  onCancel,
  onSave,
  yesButtonText = 'Yes',
  noButtonText = 'No',
}: {
  message: string;
  open: boolean;
  setOpen: () => void;
  onCancel: () => void;
  onSave: () => void;
  yesButtonText?: string;
  noButtonText?: string;
}): JSX.Element => {
  return (
    <AccessibleDialog
      open={open}
      onClose={setOpen}
      aria-labelledby="conf-dialog-title"
      PaperProps={{
        role: 'alertdialog',
        sx: { borderRadius: '10px' },
      }}>
      <Box
        sx={{
          p: { xs: 2, sm: '45px 40px' },
          borderRadius: '10px',
          // width: { xs: '70%', sm: '70%' },
          maxWidth: 410,
          height: { xs: '90%', md: 'unset' },
          overflowY: 'auto',
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiButton-root': {
              minWidth: 100,
              fontSize: 16,
            },
          }}>
          <Typography
            component="h3"
            id="conf-dialog-title"
            sx={{
              fontSize: 20,
              fontWeight: 500,
              color: '#2057A6',
              textAlign: 'center',
              mb: 5,
            }}>
            {message}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <Button
              variant="contained"
              onClick={onSave}
              sx={{ color: 'common.white', minWidth: 100 }}
              autoFocus>
              {yesButtonText}
            </Button>
            <Button
              variant="outlined"
              onClick={onCancel}
              sx={{ color: 'primary.main', minWidth: 100 }}>
              {noButtonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </AccessibleDialog>
  );
};

type Props = DialogProps & {
  title?: string;
  content: string;
  actions: {
    label: string;
    onClick: () => void;
  }[];
};

export default function SimpleDialog({ title, ...props }: Props): JSX.Element {
  const { onClose, ...rest } = props;
  return (
    <AccessibleDialog
      {...rest}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          textAlign: 'center',
          color: '#4f4f4f',
        },
        '& .MuiDialogContent-root': {
          textAlign: 'center',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
      }}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.actions.map((action, index) => (
          <Button variant="contained" color="primary" key={index} onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </AccessibleDialog>
  );
}

export function CommonLayoutForPOA(): JSX.Element {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  return (
    <>
      <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: { xs: 0, sm: '48px' },
            paddingLeft: { xs: 0, sm: '48px' },
          }}>
          <CardMedia
            component="img"
            src="/images/kfin-logo.svg"
            alt="kFintech Logo"
            sx={{ width: 'unset', m: 3 }}
          />
          {role !== USER_ROLES.INVESTOR && (
            <Box sx={{ display: 'flex' }}>
              <IconButton aria-label="Logout" onClick={() => dispatch(logout())}>
                <PowerSettingsNewIcon fontSize="large" sx={{ color: 'primary.main' }} />
              </IconButton>
            </Box>
          )}
        </Box>
      </AppBar>
      <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
    </>
  );
}

export function CountryCodesDropDown({
  name,
  value,
  readOnly = false,
  disabled = false,
  ElementWidth,
  onChange,
  ariaLabel = 'Country code selector',
}: SelectProps & {
  name: string;
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  ElementWidth?: number | null;
  onChange?: (event: SelectChangeEvent<unknown>) => void;
  ariaLabel?: string;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [query, setQuery] = useState('');
  const [field] = useField(name);
  onChange = onChange || field.onChange;

  return (
    <InputAdornment
      position="start"
      sx={{
        pr: '0 !important',
        mx: '0 !important',
      }}>
      <Box
        sx={{
          '.MuiOutlinedInput-root': {
            marginTop: '0',
            '&.MuiInputBase-root': {
              '& .MuiSelect-select': {
                padding: '12px 15px 12px 0',
                border: 'none',
              },
            },
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          },

          '&.Mui-focused,&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderWidth: 'none',
            },
          },
          svg: {
            color: '#337FC9',
          },
        }}>
        <Select
          inputProps={{
            'aria-label': ariaLabel,
          }}
          {...field}
          onChange={onChange}
          value={value}
          renderValue={(value) => {
            return (
              <Typography component="span">
                {value.split(':')[1] ? value.split(':')[1].trim() : value}
              </Typography>
            );
          }}
          MenuProps={{
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            sx: {
              '.MuiPaper-root ': {
                width: ElementWidth,
                ml: '-10px',
                maxHeight: '20%',
                overflowX: 'auto',
              },
            },
            // FIX: Restores active index tracking so keyboard arrow navigation works
            disableAutoFocusItem: false,
            MenuListProps: {
              disableListWrap: true,
            },
          }}
          onClose={() => {
            setQuery('');
          }}
          readOnly={readOnly}
          disabled={disabled}>
          {/* FIX: Wraps custom search elements inside a list container that forwards structural tab index hooks */}
          <Box
            onKeyDown={(e) => {
              // Prevents Space/Arrow event bubbling from closing menu prematurely when typing in search field
              if (e.key === ' ' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.stopPropagation();
              }
            }}
            sx={{ p: 1 }}>
            <SearchFieldWrapper searchFieldPlaceholder={'Search...'} setQuery={setQuery} />
          </Box>
          {renderFilteredOptions(
            getCountryCodes().map((codes) => ({
              key: codes.label,
              value: codes.label,
            })),
            query
          )}
        </Select>
      </Box>
    </InputAdornment>
  );
}

export interface AmlPopupValues {
  amlComments: string;
  amlAcknowledgement: boolean;
}

const amlPopupInitialValues: AmlPopupValues = {
  amlComments: '',
  amlAcknowledgement: false,
};
const amlPopupValidation = yup.object().shape({
  amlComments: yup.string().required('Field is required'),
  amlAcknowledgement: yup.bool().test('amlAcknowledgement', 'Field is required', (value) => {
    return value || false;
  }),
});

export function AmlPopup({
  handleClose,
  amlPopupOpen,
  onSubmit,
  FURTHER_INFORMATION,
  EXTERNAL_SOURCES,
  displayDocInfo = false,
}: {
  handleClose: () => void;
  amlPopupOpen: boolean;
  onSubmit: (values: AmlPopupValues) => void;
  FURTHER_INFORMATION?: string;
  EXTERNAL_SOURCES?: string;
  displayDocInfo?: boolean;
}): JSX.Element {
  return (
    <AccessibleDialog
      onClose={handleClose}
      open={amlPopupOpen}
      sx={{
        '.MuiPaper-root ': {
          p: 2,
          width: { xs: '100%', sm: '70%' },
        },
      }}>
      <Box sx={{ mb: 2, mt: 1 }}>
        <CardMedia
          component="img"
          src="/images/warning-icon-red.svg"
          alt="Warning icon"
          sx={{ width: '50px', mx: 'auto' }}
        />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '89%' },
          mx: 'auto',
        }}>
        <Typography
          component="h3"
          sx={{
            color: '#BD2932',
            textAlign: 'center',
            mb: 1,
            fontSize: 14,
            fontWeight: 500,
          }}>
          Sorry, this PAN has failed the AML check
        </Typography>
        <Typography
          component="h4"
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            mb: 0.5,
          }}>
          Further Information:
        </Typography>
        <Box
          sx={{
            width: '100%',
            height: '25vh',
            overflowY: 'auto',
            overflowWrap: 'anywhere',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}>
          <Typography
            component="h4"
            sx={{
              color: 'rgba(0,0,0,0.7)',
              textAlign: 'start',
              m: 2,
              fontSize: 14,
              fontWeight: 500,
            }}>
            {FURTHER_INFORMATION || ''}
          </Typography>
          <Typography
            component="h4"
            sx={{
              color: 'primary.main',
              textAlign: 'start',
              ml: 2,
              fontSize: 16,
              fontWeight: 600,
            }}>
            Reference Links
          </Typography>
          <Typography
            component="p"
            sx={{
              color: 'rgb(0, 0, 255)',
              textAlign: 'start',
              fontSize: 14,
              fontWeight: 500,
              m: 2,
              mt: 0.5,
            }}>
            {EXTERNAL_SOURCES || ''}
          </Typography>
        </Box>
        <Typography
          component="p"
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            fontSize: 14,
            fontWeight: 500,
            mt: 3,
            mb: 0,
          }}>
          If you still wish to proceed with this PAN, please provide reason below.
        </Typography>
        <Formik
          initialValues={amlPopupInitialValues}
          onSubmit={onSubmit}
          validationSchema={amlPopupValidation}>
          {({ handleSubmit, values }) => (
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
                '.MuiTypography-root': {
                  fontSize: 15,
                  fontWeight: 500,
                },
              }}>
              <MFTextField
                name="amlComments"
                multiline
                rows={3}
                inputProps={{
                  maxLength: 1024,
                }}
                placeholder="Type here..."
                displayCharecterCounter={'1024'}
                sx={{
                  color: 'rgba(0,0,0,0.7)',
                  pl: 0.5,
                  pt: 0.5,
                  '&.MuiInputBase-root': {
                    fontSize: 14,
                    fontWeight: 500,
                  },
                }}
              />
              <MFCheckbox
                name={`amlAcknowledgement`}
                label="I understand the risks and acknowledge to proceed further."
                sx={{ mt: 1 }}
              />
              {values.amlAcknowledgement && displayDocInfo && (
                <Typography
                  component="p"
                  sx={{
                    color: 'primary.main',
                    textAlign: 'center',
                    fontSize: 14,
                    fontWeight: 500,
                    mt: 1,
                    mb: 0,
                  }}>
                  Please upload compliance document in document details.
                </Typography>
              )}
              <Grid container sx={{ mt: 3, mb: 1, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  type="submit">
                  Proceed
                </Button>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </AccessibleDialog>
  );
}

export function AmlDetailsFields({
  amlCheck,
  amlCommentedRole,
  amlComments,
}: {
  amlCheck: boolean | undefined;
  amlCommentedRole: string | undefined;
  amlComments: string | undefined;
}): JSX.Element {
  return (
    <Grid
      item
      container
      rowSpacing={3}
      pb={2}
      columnSpacing={13}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ paddingLeft: { xs: 0, sm: '10%' } }}>
      <KeyValue title={'Aml Check'} description={amlCheck?.toString().toUpperCase() || ''} />
      <KeyValue title={'Commented By'} description={amlCommentedRole?.toUpperCase() || ''} />
      <Grid item xs={12}>
        <Item>{'Comments'}</Item>
        <ItemDetails> {amlComments || '-'}</ItemDetails>
      </Grid>
    </Grid>
  );
}
export function AmlDetails({
  applicants = [],
  applicationType,
}: {
  applicants: Partial<Applicant>[];
  applicationType: string;
}): JSX.Element {
  return (
    <>
      {!applicants.every((applicant) => applicant.amlCheck) && (
        <Box
          sx={{
            bgcolor: 'white',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: '10px',
          }}
          my={5}>
          <Box sx={{ p: 2 }}>
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <Typography
                  component="h2"
                  sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                  Aml Check Details
                </Typography>
              </Grid>
              {applicants
                .filter((applicant) => !applicant.amlCheck)
                .map((applicant, index: number) => {
                  const title = [
                    'First Applicant Details',
                    'Second Applicant Details',
                    'Third Applicant Details',
                  ][Number(applicant.applicant_type) - 1];
                  return (
                    <React.Fragment key={applicant.id}>
                      {applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && (
                        <SubHeading
                          sx={{
                            color: 'common.black',
                            letterSpacing: 0.5 + 'px',
                            padding: { xs: '10px 10px', sm: '10px 30px' },
                          }}>
                          {title}
                        </SubHeading>
                      )}
                      <AmlDetailsFields
                        amlCheck={applicant.amlCheck}
                        amlCommentedRole={applicant.amlCommentedRole}
                        amlComments={applicant.amlComments}
                      />
                    </React.Fragment>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}

export const LoadingDialog = ({
  loadingPopup,
  onLoadingPopupClose,
  loaderText = 'Loading',
}: {
  loadingPopup: boolean;
  onLoadingPopupClose: () => void;
  loaderText?: string;
}): JSX.Element => {
  return (
    <AccessibleDialog
      onClose={onLoadingPopupClose}
      open={loadingPopup}
      sx={{
        '.MuiPaper-root ': {
          p: 4,
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 20,
            fontWeight: 500,
          },
        }}>
        <Typography
          component="h3"
          sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
          {loaderText}...
        </Typography>
      </Box>
    </AccessibleDialog>
  );
};

export const NavigationThrowErrorPopup = ({
  handleClose,
  errorOpen,
  onSave,
}: {
  handleClose: () => void;
  errorOpen: {
    message: string;
    open: boolean;
  };
  onSave: () => void;
}): JSX.Element => {
  return (
    <AccessibleDialog
      //onClose={handleClose}
      open={errorOpen.open}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          textAlign: 'center',
          color: '#4f4f4f',
        },
        '& .MuiDialogContent-root': {
          textAlign: 'center',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
      }}>
      <DialogContent>
        <DialogContentText>{errorOpen.message}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="primary" variant="contained" onClick={onSave} sx={{ color: 'common.white' }}>
          OK
        </Button>
      </DialogActions>
    </AccessibleDialog>
  );
};

export const InvestorConsentBeforeEsign = ({
  handleClose,
  open,
  consentDetails,
}: {
  handleClose: () => void;
  open: any;
  consentDetails: InvestorConsentDetailsProps[];
}): JSX.Element => {
  return (
    <AccessibleDialog
      onClose={handleClose}
      open={open !== null}
      sx={{
        '.MuiPaper-root ': {
          width: { xs: '90%', sm: '70%' },
        },
      }}>
      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={4}
        pb={2}>
        <Typography
          component="h2"
          sx={{ color: 'primary.main', fontSize: '20px', fontWeight: 500 }}>
          Consent Status
        </Typography>
        <IconButton onClick={handleClose} aria-label="Close">
          <CloseIcon fontSize="medium" sx={{ color: 'secondary.main' }} />
        </IconButton>
      </Grid>
      {consentDetails &&
        consentDetails.map((details, index) => {
          return (
            <React.Fragment key={index}>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                px={4}
                py={1}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                  ':last-of-type': {
                    mb: 5,
                  },
                }}>
                <Typography
                  component="p"
                  sx={{
                    color: 'rgba(41, 49, 57, 0.7)',
                    fontSize: '18px',
                    fontWeight: 500,
                  }}>
                  {details.applicantName}
                </Typography>
                <Typography
                  component="span"
                  className={details.consentStatus}
                  sx={{
                    textDecoration: 'none',
                    fontWeight: 500,
                    fontSize: 14,
                    color: '#996E09 !important',
                    '&.Pending': {
                      color: '#2057A6 !important',
                    },
                    '&.Completed': {
                      fontWeight: 600,
                      color: '#4B8251 !important',
                    },
                    '&.Rejected': {
                      color: '#BD2932 !important',
                      fontWeight: 500,
                    },
                  }}>
                  {details.consentStatus}
                </Typography>
              </Grid>
            </React.Fragment>
          );
        })}
    </AccessibleDialog>
  );
};

export const KycUpdateStatus = ({
  handleClose,
  open,
  applicantsData,
}: {
  handleClose: () => void;
  open: any;
  applicantsData: Partial<Applicant>[];
}): JSX.Element => {
  return (
    <AccessibleDialog
      onClose={handleClose}
      open={open !== null}
      sx={{
        '.MuiPaper-root ': {
          width: { xs: '90%', sm: '70%' },
        },
      }}>
      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={4}
        pb={2}>
        <Typography
          component="h2"
          sx={{ color: 'primary.main', fontSize: '20px', fontWeight: 500 }}>
          KYC Update Status
        </Typography>
        <IconButton onClick={handleClose} aria-label="Close">
          <CloseIcon fontSize="medium" sx={{ color: 'secondary.main' }} />
        </IconButton>
      </Grid>
      {applicantsData &&
        applicantsData.map((details, index) => {
          const cvlFormSign = APPLICANT_CVL_FORM_SIGNING_STATUS[details.cvlFormSigningStatus || ''];
          const CvlModified = CVL_MODIFICATION_STATUS[details.cvlModificationStatus || ''];
          return (
            <React.Fragment key={index}>
              <Typography
                component="p"
                sx={{
                  color: 'rgba(41, 49, 57, 0.7)',
                  fontSize: '18px',
                  fontWeight: 500,
                  px: 4,
                }}>
                {details.name}
              </Typography>
              <Box
                sx={{
                  bgcolor: 'white',
                  boxShadow: '0px 4px 12px rgba(204,204,204,1)',
                  borderRadius: '10px',
                  mx: 4,
                  my: 2,
                }}>
                <Grid
                  container
                  direction="column"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    ':last-of-type': {
                      mb: 1,
                    },
                  }}>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      px: 3,
                      py: 1,
                    }}>
                    <Typography
                      component="p"
                      sx={{
                        color: 'rgba(41, 49, 57, 0.7)',
                        fontSize: '18px',
                        fontWeight: 500,
                      }}>
                      Opted for KYC update
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        textDecoration: 'none',
                        fontWeight: 500,
                        fontSize: 16,
                        color: '#2057A6 !important',
                      }}>
                      {checkKycUpdateCheck(details) ? 'Yes' : 'No'}
                    </Typography>
                  </Box>
                  {cvlFormSign && (
                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 3,
                        py: 1,
                      }}>
                      <Typography
                        component="p"
                        sx={{
                          color: 'rgba(41, 49, 57, 0.7)',
                          fontSize: '18px',
                          fontWeight: 500,
                        }}>
                        KYC Form signing
                      </Typography>
                      <Typography
                        component="span"
                        className={cvlFormSign}
                        sx={{
                          textDecoration: 'none',
                          fontWeight: 500,
                          fontSize: 16,
                          color: '#996E09 !important',
                          '&.Pending': {
                            color: '#2057A6 !important',
                          },
                          '&.Completed': {
                            fontWeight: 600,
                            color: '#4B8251 !important',
                          },
                          '&.Signed': {
                            fontWeight: 600,
                            color: '#4B8251 !important',
                          },
                        }}>
                        {cvlFormSign}
                      </Typography>
                    </Box>
                  )}
                  {CvlModified && (
                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 3,
                        py: 1,
                      }}>
                      <Typography
                        component="p"
                        sx={{
                          color: 'rgba(41, 49, 57, 0.7)',
                          fontSize: '18px',
                          fontWeight: 500,
                        }}>
                        CVL updated status
                      </Typography>
                      <Typography
                        component="span"
                        className={CvlModified}
                        sx={{
                          textDecoration: 'none',
                          fontWeight: 500,
                          fontSize: 16,
                          color: '#996E09 !important',
                          '&.Hold': {
                            color: '#2057A6 !important',
                          },
                          '&.Registered': {
                            fontWeight: 600,
                            color: '#4B8251 !important',
                          },
                          '&.Failed': {
                            color: '#BD2932 !important',
                            fontWeight: 500,
                          },
                          '&.Rejected': {
                            color: '#BD2932 !important',
                            fontWeight: 500,
                          },
                          '&.Deactivated': {
                            color: '#BD2932 !important',
                            fontWeight: 500,
                          },
                        }}>
                        {CvlModified}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Box>
            </React.Fragment>
          );
        })}
    </AccessibleDialog>
  );
};

export const FileUploadDialog = ({
  show,
  handleClose,
  message,
  code,
}: {
  show: boolean;
  handleClose: () => void;
  message?: string;
  code: string;
}): JSX.Element => {
  return (
    <AccessibleDialog
      open={show}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          color: '#4f4f4f',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
      }}>
      <DialogContent>
        <DialogContentText>
          {' '}
          <Typography component="p" sx={{ textAlign: 'center' }}>
            {message}
          </Typography>
          {code === 'FILE_ENCRYPTION_ERROR' && (
            <>
              <Typography component="span" fontWeight={450} mt={2}>
                {' '}
                Steps for flattening PDF
              </Typography>
              <Typography component="span" mt={1}>
                &bull; Right click on the file, and navigate to “Open With” and choose Chrome
                browser.
              </Typography>
              <Typography component="span">
                &bull; Then Open the print menu by pressing Ctrl+P
              </Typography>
              <Typography component="span">
                &bull; Under the “Printer” drop-down menu, select “Microsoft Print to PDF” or “Save
                as PDF”.
              </Typography>
              <Typography component="span"> &bull; Click “Print”.</Typography>
              <Typography component="span">
                &bull; When prompted, choose where you want to save the file.
              </Typography>
              <Typography component="span"> &bull; Upload the newly saved file.</Typography>
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          ok
        </Button>
      </DialogActions>
    </AccessibleDialog>
  );
};

interface SectionHeaderProps {
  title: string;
  showIcon?: boolean;
  iconSrc?: string;
  iconAlt?: string;
  actionText?: string;
  disabled?: boolean; // Added control for disable flag states
  customIcon?: React.ReactNode; // Added support for custom SVG icon components
  onIconClick?: () => void;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  showIcon = false,
  iconSrc = '/images/edit-icon-outlined.svg',
  iconAlt = 'Action Icon',
  actionText,
  disabled = false,
  customIcon,
  onIconClick,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'rgba(221, 234, 243, 0.34)',
        borderRadius: '5px',
        width: '100%',
        letterSpacing: '1px',
        marginTop: '30px',
        marginBottom: '30px',
      }}>
      <Typography
        component="span"
        sx={{
          color: 'common.black',
          letterSpacing: '0.5px',
          fontSize: '14px',
          fontWeight: 600,
          padding: { xs: '10px 10px', sm: '10px 30px' },
        }}>
        {title}
      </Typography>

      {showIcon && onIconClick && (
        <Box
          role="button"
          title={`${iconAlt} ${title}`}
          aria-label={`${iconAlt} ${title}`}
          tabIndex={disabled ? -1 : 0}
          onClick={disabled ? undefined : onIconClick}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              onIconClick();
            }
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: disabled ? 'not-allowed' : 'pointer',
            pointerEvents: disabled ? 'none' : 'all',
            padding: { xs: '10px 10px', sm: '10px 30px' },
            textTransform: 'none',
            letterSpacing: 'normal',
            fontWeight: 'normal',
            opacity: disabled ? 0.5 : 1,
          }}>
          {actionText && (
            <Typography
              component="span"
              sx={{
                color: '#E50000',
                fontSize: 13,
                marginRight: '8px',
                letterSpacing: '-0.2px',
              }}>
              {actionText}
            </Typography>
          )}

          {customIcon ? (
            customIcon
          ) : (
            <img
              src={iconSrc}
              alt={iconAlt}
              style={{
                width: '18px',
                height: '18px',
              }}
            />
          )}
        </Box>
      )}
    </Box>
  );
};
